var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.83331V3.66665M5.5 1.83331V3.66665",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9959 11.9167H11.0041M10.9959 15.5834H11.0041M14.6584 11.9167H14.6666M7.33331 11.9167H7.34154M7.33331 15.5834H7.34154",
    stroke: "#2177FE",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20831 7.33331H18.7916",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29169 11.223C2.29169 7.22878 2.29169 5.23168 3.43946 3.99084C4.58724 2.75 6.43455 2.75 10.1292 2.75H11.8709C15.5655 2.75 17.4128 2.75 18.5606 3.99084C19.7084 5.23168 19.7084 7.22878 19.7084 11.223V11.6937C19.7084 15.6879 19.7084 17.685 18.5606 18.9258C17.4128 20.1667 15.5655 20.1667 11.8709 20.1667H10.1292C6.43455 20.1667 4.58724 20.1667 3.43946 18.9258C2.29169 17.685 2.29169 15.6879 2.29169 11.6937V11.223Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 7.33331H19.25",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar03);
export default __webpack_public_path__ + "static/media/calendar-03.b9c5b87e1d755d46bf89bd0ce0d2f745.svg";
export { ForwardRef as ReactComponent };